import { environment } from '@env/environment';
import { provideEnvironmentInitializer } from '@angular/core';
import { getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

export const fireProviders = [
  provideEnvironmentInitializer(() => {
    const app =
      getApps().find(({ name }) => name === environment.firebase.appId) ||
      initializeApp(environment.firebase, environment.firebase.appId);

    getAuth(app);
    getDatabase(app);
  }),
];
